<template>
  <basic-container>

    <div style="overflow:hidden;padding: 0;margin-bottom:20px">
      <el-button size="small" type="primary" style="float:left;" icon="el-icon-plus" @click="addRemarkTemplate">新 建</el-button>
    </div>
    <el-table :data="remarkTemplateList" id="templateTable" :border='true'>
      <el-table-column
        label="序号"
        type="index"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="内容"
      >
      </el-table-column>
      <el-table-column
        prop="subModuleName"
        label="子类型名称"
      >
      </el-table-column>
      <el-table-column
        width="210"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" style="display:inline-block;" @click="editHandler(scope.row)" >编辑</el-button><el-button type="text" style="display:inline-block;" @click="deleteHandler(scope.row)">删除</el-button>
          <el-button type="text" style="display:inline-block;" @click="upHandler(scope.row)">上移</el-button>
          <el-button type="text" style="display:inline-block;" @click="downHandler(scope.row)">下移</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-dialog
      append-to-body
      :visible.sync="addRemarkTemplateVisible"
      class="newTemplateDialog"
      title="新增">
      
    </el-dialog> -->
    <hr-dialog
      title="新增"
      :visible.sync="addRemarkTemplateVisible"
      class="newTemplateDialog"
      width="50%"
    >
      <template v-slot:body>
        <el-form label-width="100px" label-position="right">
          <el-row :span='24'>
            <el-col :span='24'>
              <el-form-item label="子类型名称">
                <el-select v-model="subModuleId" placeholder="请选择 子类型" @change="handleSubModuleChange">
                  <el-option
                    v-for="(item,index) in subModuleList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
            <!-- <el-input type="textarea" v-model="addRemarkContent" maxlength="100" placeholder="不能超过100个字"></el-input> -->
            </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-form-item label="模板内容" required>
                <el-input type="textarea" style="display:inline-block;width:50%;" v-model="addRemarkContent" maxlength="100" placeholder="请输入 模板内容"></el-input>
              </el-form-item>
            </el-col>
          
          <!-- <el-form-item>
            <el-button type="primary"  :disabled ="submitButtonDisabled" @click.native="submitAddData">
              提交
            </el-button>
            <el-button @click.native="addRemarkTemplateVisible=false">
              取消
            </el-button>
          </el-form-item> -->
          </el-row>
          
      </el-form>
      </template>
      <template slot="footer">
        <div style="text-align: right; margin-right:20px">
                      <el-button size="small" type="primary" :disabled ="submitButtonDisabled" @click.native="submitAddData" icon="el-icon-circle-plus-outline"
                        >保存</el-button
                      >
                      <el-button size="small" icon="el-icon-circle-close" @click.native="addRemarkTemplateVisible=false">取消</el-button>
                    </div>
      </template>
    </hr-dialog>
    <hr-dialog 
          title="编辑模板"
          ref="remarkTemp"
          :visible.sync="editRemarkTemplateVisible"
          width="35%"
          :handleClose='handleClose'>
          <template
          
           v-slot:body>
             <el-form label-width="100px" label-position="right">
               <el-row :gutter="24">
                 <el-col :span="24">
                    <el-form-item label="子类型名称">
                        <el-select v-model="subModuleId" placeholder="请选择子类型" @change="handleSubModuleChange">
                          <el-option
                            v-for="(item,index) in subModuleList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <!-- <el-input type="textarea" v-model="addRemarkContent" maxlength="100" placeholder="不能超过100个字"></el-input> -->
                    </el-form-item>
                 </el-col>

                <el-col :span="24">
                  <el-form-item label="模板内容" required>
                    <el-input type="textarea"  v-model="editRemarkTemplateRow.remark" maxlength="100" placeholder="不能超过100个字"></el-input>
                  </el-form-item>
                </el-col>
                  
               </el-row>
              </el-form>
          </template>
          <template slot="footer">
            <div style="text-align: right; margin-right:20px">
                      <el-button type="primary" @click.native="submitEditData" icon="el-icon-circle-plus-outline"
                        >保存</el-button
                      >
                      <el-button icon="el-icon-circle-close" @click.native="editRemarkTemplateVisible=false">取消</el-button>
                    </div>
          </template>
       </hr-dialog>

    <!-- <el-dialog
      append-to-body
      :visible.sync="editRemarkTemplateVisible"
      width="35%"
      class="newTemplateDialog"
      title="编辑模板">
      
    </el-dialog> -->
  </basic-container>
</template>

<script>

  import {
    getList,
    add,
    remove,
    up,
    down,
    update,
    getSubModuleList
  } from '@/api/v4ward/gateservice/ordersetting/remarktemplate/ordersettingremarktemplate';
import { type } from 'os';

  // import {} from '@/api/v4ward/gateservice/ordersetting/remarktemplate/ordersettingremarktemplate';
  export default {
    props: ['projectId', 'actionRow', 'componentRow'],
    data() {
      return {
        subModuleList:[],
        subModuleId:'',
        subModuleName:'',
        submitButtonDisabled: false,
        editRemarkTemplateRow: {},
        addRemarkContent: '',
        editRemarkContent: '',
        dialogUserEditBoxVisible: false,
        editRemarkTemplateVisible: false,
        addRemarkTemplateVisible: false,
        remarkTemplateList: [],
        param: {},
      }
    },
    mounted() {

    },
    created() {
      this.param = {settingId: this.actionRow.settingId,workStatus: this.actionRow.workStatus,actionType:this.actionRow.actionType};
      console.log("this.actionRow======>",this.actionRow);
      console.log("this.componentRow======>",this.componentRow);
      getSubModuleList({moduleType: this.componentRow.moduleType, projectId:this.componentRow.projectId}).then((res)=>{
        console.log(res);
        this.subModuleList = res.data;
      });
      getList(this.param).then((res) => {
        this.remarkTemplateList = res.data;
      });
    },
    computed: {},
    methods: {
      onContentFocus() {
        this.submitButtonDisabled = false;
      },
      handleSubModuleChange(val){

        this.subModuleList.forEach(ele=>{
          if(ele.id === val){

            this.subModuleName = ele.name;
            console.log(this.subModuleName);
          }
        });
        console.log("handleSubModuleChange====>",val);
      },
      addRemarkTemplate() {
        this.addRemarkTemplateVisible = true;
        this.submitButtonDisabled = false;
        this.addRemarkContent = '';
        this.subModuleId = '';
        this.subModuleName = '';
      },
      submitAddData() {
        this.submitButtonDisabled = true;
        let self = this;
        if(!this.addRemarkContent){
          this.$message.error('请填写模板内容！');
          this.submitButtonDisabled = false;
          return;
        }
        let param = {
          settingId: this.actionRow.settingId,
          remark: this.addRemarkContent,
          workStatus: this.actionRow.workStatus,
          actionType: this.actionRow.actionType,
          subModuleId: this.subModuleId,
          subModuleName: this.subModuleName
        };
        add(param).then((res) => {
          setTimeout(() => this.submitButtonDisabled = false,1000);
          console.log(res);
          getList(this.param).then((res) => {
            console.log(res);
            self.remarkTemplateList = res.data;
            self.addRemarkTemplateVisible = false;
          });
        }).catch(err => {
          console.log(err);
          this.submitButtonDisabled = false;
        });
      },

      deleteHandler(row) {
        
        this.$confirm("确定要删除吗？", "警告", {
          type: "warning",
        })
          .then(() => {
            remove({ids: row.id}).then((res) => {
              console.log(res);
              getList(this.param).then((res) => {
                console.log(res);
                this.remarkTemplateList = res.data;
              });
            });
          })
          .catch(() => {});
      },
      upHandler(row) {
        let self = this;
        up(row).then((res) => {
          console.log(res);
          getList(this.param).then((res) => {
            console.log(res);
            self.remarkTemplateList = res.data;
          });
        });
      },
      downHandler(row) {
        down(row).then((res) => {
          console.log(res);
          getList(this.param).then((res) => {
            console.log(res);
            this.remarkTemplateList = res.data;
          });
        });
      },
      editHandler(row) {
        console.log(this.$refs.remarkTemp)
        this.editRemarkTemplateVisible = true;
        this.editRemarkTemplateRow = row;
        if(typeof(this.subModuleList.forEach)=="function"){
          this.subModuleList.forEach(ele=>{
          if(ele.id === this.editRemarkTemplateRow.subModuleId){

            this.subModuleName = ele.name;
            console.log(this.subModuleName);
          }
        });
        }
        
        // console.log("handleSubModuleChange====>",val);
      },
      submitEditData() {
        this.submitButtonDisabled = true;
        if(!this.editRemarkTemplateRow.remark){
          this.$message.error('请填写模板内容！');
          return;
        }
        let self = this;
        this.editRemarkTemplateRow.subModuleName = this.subModuleName;
        update(this.editRemarkTemplateRow).then((res) => {
          console.log(res);
          getList(this.param).then((res) => {
            console.log(res);
            this.remarkTemplateList = res.data;
            self.editRemarkTemplateVisible = false;
          });
        })
      },
    }
  }
</script>

<style>
  div[class="el-dialog__wrapper newTemplateDialog"] .el-dialog__body{
    padding-top: 15px;
    padding-bottom: 10px;
  }
  div[id="templateTable"] td{
    padding: 0;
  }

  div[id="templateTable"]  .el-button {
    margin-left: 5px;
    margin-right: 5px;
  }
  div[id="templateTable"]  .cell {
    text-align: center;
  }
</style>
